import { AxiosInstance } from "axios";
import { onUnauthenticatedUser } from "src/api/utils/interceptors/onUnauthenticatedUser.ts";

export const setupInterceptors = (axiosClient: AxiosInstance): AxiosInstance => {
	axiosClient.interceptors.response.use(onUnauthenticatedUser);
	return axiosClient;
};
